// --- TikTok ---
// TikTok recommends storing the click ID for at least 28 days.
// See https://business-api.tiktok.com/portal/docs/send-tiktok-click-id-ttclid/v1.3
export const TTCLID_MAX_AGE = 60 * 60 * 24 * 28;

// --- Facebook ---
// Meta's _fbc cookie attribution window is 90 days.
// See https://developers.facebook.com/documentation/ads-commerce/conversions-api/parameters/fbp-and-fbc/#3--store-the-clickid
export const FBC_MAX_AGE = 60 * 60 * 24 * 90;
export const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000;

// --- Pinterest ---
// Pinterest does not publish an explicit TTL for the _epik cookie in its
// Conversions API docs. 30 days aligns with the short-window attribution
// approach used for TikTok's ttclid in this codebase.
// See https://developers.pinterest.com/docs/track-conversions/track-conversions-in-the-api/
export const EPIK_MAX_AGE = 60 * 60 * 24 * 30;
